export default Object.freeze({
    ERRORS: {
        TIME_MUST_BE_IN_THE_FUTURE: 'CALENDAR_EVENT.TIME_MUST_BE_IN_THE_FUTURE',
        UNAVAILABLE_SLOT: 'CALENDAR_EVENT.UNAVAILABLE_SLOT',
        UNAVAILABLE_FOR_RESCHEDULING: 'CALENDAR_EVENT.UNAVAILABLE_FOR_RESCHEDULING',
        INVALID_AVAILABILITY_OFFER: 'CALENDAR_EVENT.INVALID_AVAILABILITY_OFFER',
        NOT_PERMISSIONED: 'CALENDAR_EVENT.NOT_PERMISSIONED',
        NOT_SUPPORTED_TRANSITION: 'CALENDAR_EVENT.NOT_SUPPORTED_TRANSITION',
        NOT_FOUND: 'CALENDAR_EVENT.NOT_FOUND',
        USERS_FIRST_NAME_LAST_NAME_AND_MOBILE_REQUIRED: 'CALENDAR_EVENT.USERS_FIRST_NAME_LAST_NAME_AND_MOBILE_REQUIRED',
        TIME_MUST_BE_IN_THE_PAST: 'CALENDAR_EVENT.TIME_MUST_BE_IN_THE_PAST',
        MINIMUM_DIFFERENCE_IS_: 'MINIMUM_DIFFERENCE_IS_',
        MINIMUM_DIFFERENCE_IS_20min: 'CALENDAR_EVENT.MINIMUM_DIFFERENCE_IS_20min',
        MINIMUM_DIFFERENCE_IS_60min: 'CALENDAR_EVENT.MINIMUM_DIFFERENCE_IS_60min',

        MINIMUM_5: 'CALENDAR_EVENT.MINIMUM_5',
        OVERLAP_TOO_LARGE: 'CALENDAR_EVENT.OVERLAP_TOO_LARGE',
        UNAVAILABLE_FOR_ALLOWING_OVERLAP: 'CALENDAR_EVENT.UNAVAILABLE_FOR_ALLOWING_OVERLAP',
        CALENDAR_EVENT_BLOCKED: 'CALENDAR_EVENT.BLOCKED',
    },
})
